import { PaymentRecord, paymentFromJSON } from "common/records/Payment";
import { RootActions, RootState } from "common/reducers";
import {
  PaymentActions,
  RECEIVE_PAYMENT,
  RECEIVE_PAYMENTS,
  FETCH_AUTHORIZED,
  RECEIVE_AUTHORIZED,
} from "common/reducers/payment.actions";
import { Map, Record } from "immutable";
import { receive } from "common/reducers/Utils";
import { PaymentAuthorizationRecord } from "common/records/PaymentAuthorizationRecord";

export const PaymentStateRecord = Record({
  byId: Map<number, PaymentRecord>(),
  lastSavedById: Map<number, PaymentRecord>(),
  authByOrgId: Map<number, PaymentAuthorizationRecord>(),
});

export const initialState = PaymentStateRecord();
export type PaymentState = typeof initialState;
export const model = "payments";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_PAYMENT: {
      return receive(state, model, paymentFromJSON(action.payload.payment));
    }

    case RECEIVE_PAYMENTS:
      action.payload.payments.forEach((p) => {
        state = reducer(state, PaymentActions.receivePayment(p));
      });

      return state;

    case FETCH_AUTHORIZED:
      if (state.getIn([model, "authByOrgId", action.payload.orgId])) {
        return state.setIn(["authByOrgId", action.payload.orgId, "loading"], true);
      }
      return state.setIn(
        [model, "authByOrgId", action.payload.orgId],
        new PaymentAuthorizationRecord({ loading: true }),
      );
    case RECEIVE_AUTHORIZED:
      return state.setIn([model, "authByOrgId", action.payload.orgId], action.payload.auth);

    default:
      return state;
  }
};
